import * as F from "./index.es5496.js";
import R from "lodash";
import { stringToRGBArray as r } from "./index.es521.js";
const o = {}, s = [
  "TRAFFIC_VOLUME_RED_4",
  "TRAFFIC_VOLUME_RED_5",
  "TRAFFIC_VOLUME_RED_6",
  "TRAFFIC_VOLUME_WINE_4",
  "TRAFFIC_VOLUME_WINE_5",
  "TRAFFIC_VOLUME_WINE_6",
  "TRAFFIC_VOLUME_GREEN_RED_4",
  "TRAFFIC_VOLUME_GREEN_RED_5",
  "TRAFFIC_VOLUME_GREEN_RED_6",
  "TRAFFIC_VOLUME_PLATFORM_4",
  "TRAFFIC_VOLUME_PLATFORM_5",
  "TRAFFIC_VOLUME_PLATFORM_6"
];
for (const t of s) {
  const _ = t, e = _.split("_").slice(1, -1).join("-").toLowerCase(), E = t;
  o[_] = {
    paletteName: R.startCase(e),
    paletteColors: r(F[E])
  };
}
const C = (t) => Object.entries(o).map(([_, e]) => _.includes(t.toString()) ? e : void 0).filter((_) => _);
export {
  o as TRAFFIC_VOLUME_PALETTE_DICTIONARY,
  C as getTrafficVolumePalettesDictionary,
  s as paletteKeys
};
//# sourceMappingURL=index.es50.js.map
